module.exports = __webpack_public_path__ + "img/bulgaria.08c8663f.svg";